import { render, staticRenderFns } from "./product-gallery.vue?vue&type=template&id=6ed25c0d&"
import script from "./product-gallery.vue?vue&type=script&lang=js&"
export * from "./product-gallery.vue?vue&type=script&lang=js&"
import style0 from "./product-gallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports